var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAppDispatch } from 'root/src/client/logic/helpers/useStore';
import { useMutation } from '@tanstack/react-query';
import createProjectDrop from 'root/src/client/logic/project/thunks/createProjectDrop';
export function useCreateProjectDropMutation() {
    const dispatch = useAppDispatch();
    return useMutation({
        mutationKey: ['createProjectDrop'],
        mutationFn: (params) => __awaiter(this, void 0, void 0, function* () {
            // @ts-ignore
            const response = yield dispatch(createProjectDrop(params, params.showSuccessModal));
            if (response.error) {
                throw response.error;
            }
            return response.body;
        }),
    });
}
